import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { listarArchivos } from '../services/api';
import { useAuthValidation } from '../hooks/useAuthValidation';

const ArchiveHistory = () => {
  useAuthValidation();
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadArchives();
  }, []);

  const loadArchives = async () => {
    setLoading(true);
    try {
      const data = await listarArchivos();
      setArchives(data.archives || []);
    } catch (error) {
      console.error('Error cargando archivos:', error);
      toast.error('Error al cargar historial de archivos');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString('es-PY');
  };

  return (
    <div className="archive-history">
      <h3>Historial de Archivos Generados</h3>

      <div className="card shadow-sm mt-4">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th>Identificador</th>
                  <th>Nombre de Archivo</th>
                  <th>Periodo</th>
                  <th>Formato</th>
                  <th>Comprobantes</th>
                  <th>Fecha Generación</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </td>
                  </tr>
                ) : archives.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      <i className="bi bi-inbox"></i>
                      <br />
                      No hay archivos generados todavía.
                    </td>
                  </tr>
                ) : (
                  archives.map((archivo) => (
                    <tr key={archivo.file_id}>
                      <td>
                        <span
                          className={`badge ${
                            archivo.file_id.startsWith('C')
                              ? 'bg-primary'
                              : 'bg-success'
                          }`}
                        >
                          {archivo.file_id}
                        </span>
                      </td>
                      <td>
                        <code>{archivo.nombre_archivo}</code>
                      </td>
                      <td>{archivo.periodo}</td>
                      <td>
                        <span className="badge bg-info">
                          {archivo.formato.toUpperCase()}
                        </span>
                      </td>
                      <td>
                        <span className="badge bg-secondary">
                          {archivo.cantidad_comprobantes}
                        </span>
                      </td>
                      <td>{formatDate(archivo.fecha_generacion)}</td>
                      <td>
                        <span className="badge bg-success">{archivo.estado}</span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {archives.length > 0 && (
        <div className="alert alert-info mt-4">
          <i className="bi bi-info-circle"></i>
          <strong> Información:</strong>
          <ul className="mb-0 mt-2">
            <li>
              <strong>C####:</strong> Archivos mensuales
            </li>
            <li>
              <strong>A####:</strong> Archivos anuales
            </li>
            <li>Solo se exportan comprobantes que no han sido enviados anteriormente</li>
            <li>Los comprobantes se marcan automáticamente como exportados</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ArchiveHistory;
